
export class J3WindowBase extends EventTarget {
    overlay;
    target;
    btn_target_close;
    //CallBack;
    state;
    id: string = '';   //ボタン名


    constructor(targetID: string, public debugLvl = 0, public syncOverlay = true) {
        super();    //'this'を使う前にsuper()を実行する必要がある
        this.id = targetID;
    }

    SetButtons(targetID: string) {
        //console.log('Setbuttons targetID', targetID);
        this.overlay = document.getElementById('overlay');
        this.target = document.getElementById(targetID);
        if (this.target)
            this.btn_target_close = document.querySelector('#' + targetID + ' .close button')
        if (this.btn_target_close) {
            this.btn_target_close.addEventListener("click", (e: Event) => {
                this.Hide(true);
            });
            //console.log('Setbuttons this.id', this.id);
        }
        this.Hide();
    }

    //オーバーレイの有効・無効（マウス操作のブロック）
    OverlayOn() {
        //console.log("OverlayOn");
        if (this.overlay && this.syncOverlay) this.overlay.style.pointerEvents = 'all';
    }
    OverlayOff() {
        //console.log("OverlayOff")
        if (this.overlay && this.syncOverlay) this.overlay.style.pointerEvents = 'none';
    }

    //要素の表示・非表示共通関数

    protected SetTitle(title: string) {
        if (this.debugLvl > 2) console.log(title);
        if (this.target) this.target.getElementsByClassName('pop_title')[0].innerHTML = title;
    }

    Simple() {
        let event = new CustomEvent("simple", { detail: { id: this.id } });
        this.dispatchEvent(event);
    }

    TemporaryShow() {
        if (this.state == true) {
            if (this.debugLvl > 2) console.log("TemporaryShowTarget");
            if (this.target) this.target.style.display = 'block';
            if (this.syncOverlay) this.OverlayOn();
        }
    }

    TemporaryHide() {
        if (this.state == true) {
            if (this.debugLvl > 2) console.log("TemoraryHideTarget");
            if (this.target) this.target.style.display = 'none';
            if (this.syncOverlay) this.OverlayOff();
        }
    }

    Show(dispatchEvent = true) {
        if (this.debugLvl > 2) console.log("ShowTarget");
        console.log('Show');
        if (this.target) this.target.style.display = 'block';
        if (this.syncOverlay) this.OverlayOn();
        this.state = true;
        if (dispatchEvent) {
            let event = new CustomEvent("change", { detail: { state: this.state, id: this.id } });
            this.dispatchEvent(event);
        }
    }
    Hide(dispatchEvent = true) {
        console.log('Hide');
        if (this.target) this.target.style.display = 'none';
        this.state = false;
        if (dispatchEvent) {
            if (this.syncOverlay) this.OverlayOff();
            let event = new CustomEvent("change", { detail: { state: this.state, id: this.id } });
            this.dispatchEvent(event);
        }
    }
    Toggle(syncOverlay: boolean = true) {
        if (this.debugLvl > 2) console.log("ToggleTarget");
        if (this.state) {
            this.Hide();
        } else {
            this.Show();
        }
    }
}